export default __webpack_public_path__ + "static/media/placeholder_dummy2016-physiotherapie01-mobile-de.f0ca9892.png";